import strings from './strings';

export default function getString(stringId) {
  if (!strings[stringId]) {
    throw new Error(
      'getString failed: ' + stringId + ' not found in src/strings.js'
    );
  }

  let string = strings[stringId]['en-US'];

  return string;
}
